import { gql } from '__generated__';

export default gql(`
  mutation ReplyToWaitlistInvite($input: ReplyToWaitlistInviteInput!) {
    replyToWaitlistInvite(input: $input) {
      status
      redirect_url
    }
  }
`);
